export interface ShareIconProps {
    className: string;
}

export function ShareIcon({className = ''}: ShareIconProps) {
    return(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.51 19.51" className={`w-full ${className}`}>
        <polygon points="18.36 18.36 1.15 18.36 1.15 1.15 8.61 1.15 8.61 0 0 0 0 19.51 19.51 19.51 19.51 11.48 18.36 11.48 18.36 18.36"/>
        <path d="M18.94,0h-6.89c-.32,0-.57.26-.57.57s.26.57.57.57h5.5L5.33,13.37c-.22.22-.22.59,0,.81.11.11.26.17.41.17s.29-.06.41-.17L18.36,1.96v5.5c0,.32.26.57.57.57s.57-.26.57-.57V0h-.57Z"/>
    </svg>
    )
}